/*document.addEventListener('DOMContentLoaded', function() {
    var elems = document.querySelectorAll('.parallax');
    var instances = M.Parallax.init(elems, options);
});*/

jQuery(document).ready(function($){
    $('.scrollspy').scrollSpy(
        {'scrollOffset': 100}
    );
    $('#toggle').click(function() {
        $(this).toggleClass('active');
        $('#overlay').toggleClass('open');
    });

    $('.parallax').parallax();

    $('.owl-carousel').owlCarousel({
        items:1,
        lazyLoad:true,
        loop:true,
        autoplay: true,
        autoplayTimeout: 4000,
        /*margin:10,*/
        dots: false,
        autoHeight:true
    });

    $('.collapsible').collapsible();

    $('select').formSelect();

    if($('body').hasClass('post-type-archive-tiffanys-girls') || $('body').hasClass('post-type-archive-tiffanys-girls')) {
        var $grid = $('.masonry_grid').masonry({
            itemSelector: '.cards-container',
            percentPosition: true,

        });
// layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
            $grid.masonry();
        });
    }

    if($('body').hasClass('page-template-t-testimonials')) {
        var $gridTestimonials = $('.masonry_grid').masonry({
            itemSelector: '.cards-container',
            percentPosition: true,

        });
// layout Masonry after each image loads
        $gridTestimonials.imagesLoaded().progress(function () {
            $gridTestimonials.masonry();
        });
    }
    
    if($('body').hasClass('page-template-t-home')) {
        var $gridA = $('.masonry_grid').masonry({
            itemSelector: '.cards-container',
            percentPosition: true,

        });
// layout Masonry after each image loads
        $gridA.imagesLoaded().progress(function () {
            $gridA.masonry();
        });
    }

    /*var menu = $('.sticky-menu');
    var target = $('#' +menu.attr("data-target"));
    menu.pushpin({
        top: target.offset().top,
    });*/

    /*$('#sticky-menu').pushpin();*/

});